// Module
var code = `<select ng-options="lang as lang.name for lang in languagesEnum track by lang.code" ng-selected="model.code==lang.code"><option value="" selected="selected">Choose&hellip;</option></select>`;
// Exports
export default code;